import styled from 'styled-components';
import { colors } from 'constants/colors';
import { BasicSectionContainer } from 'screens/style';
// import setPassword from 'assets/icons/setPassword.svg';
import { styleSizes } from "constants/styleSizes";

export const SetPasswordScreenContainer = styled(BasicSectionContainer)`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .innerContainer {
    display: flex;
    justify-content: space-between;
    position: relative;
    align-items: center;
    height: 346px;
    @media (max-width: ${styleSizes.tabletBreakpoint}) {
      height: 300px;
    }
    @media (max-width: ${styleSizes.tabletBreakpoint}) {
      align-items: baseline;
      padding-top: 56px;
    }
    @media (max-width: ${styleSizes.miniBreakpoint}) {
      height: 200px;
      padding: 20px 0 0 0;
    }
  }

  .titleContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${colors.setPasswordBackground};
    width: 100%;
    height: 346px;
    padding: 0 15px;
    @media (max-width: ${styleSizes.tabletBreakpoint}) {
          height: 300px;
    }
    @media (max-width: ${styleSizes.miniBreakpoint}) {
          height: 200px;
    }
    .titleText {
      width: 100%;
      margin: 0 20px 0 0;
      @media (max-width: ${styleSizes.miniBreakpoint}) {
        margin: 12px 20px 0 0;
      }
      .title {
        font-size: 48px;
        font-weight: bold;
        line-height: 72px;
        text-align: left;
        color: ${colors.white};
        z-index: 20;
        position: relative;

        @media (max-width: 1175px) {
          font-size: 32px;
          line-height: 48px;
          .titleSecond {
            width: 342px;
          }
          
        }

        @media (max-width: ${styleSizes.miniBreakpoint}) {
          font-size: 24px;
          line-height: 32px;
          .titleSecond {
            width: 242px;
          }
          .titleFirst {
            width: 242px;
          }

        }


        .highLight {
          color: ${colors.checkOutCompleteScreenHighlight};
        }
      }
    }

    .setPasswordImage {
        position: absolute;
        right: 31px;
        bottom: 0;
        width: 457px;
        height: auto;
        z-index: 10;
        @media (max-width: ${styleSizes.tabletBreakpoint}) {
          height: 300px;
          right: 0;
          width: auto;
        }
        @media (max-width: ${styleSizes.miniBreakpoint}) {
        height: 130px;
        width: auto;
        right: 0;
        bottom: 0;
        }

      }
  }

  .inputRow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 15px;


    
    .innerContainerSetPassword {
      display: flex;
      flex-direction: column;
      width: 515px;
      min-width: 270px;
      padding: 24px 0 60px 0;
      align-items: center;

      @media (max-width: ${styleSizes.miniBreakpoint}) {
          text-align: left;
          padding: 16px 0 60px 0;
        }

      .buttonContainer {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          width: 100%;
          justify-content: flex-end;
        }
        svg {
          position: absolute;
          top: -85px;
          left: 50px;
        }
      }

      .description {
        font-size: 16px;
        font-weight: 400;
        color: ${colors.black};
        margin: 15px 0;
        line-height: 24px;
        margin-bottom: 24px;
        @media (max-width: ${styleSizes.miniBreakpoint}) {
          text-align: left;
          margin: 0 0 24px 0;
        }
        .highLight {
          font-weight: 600;
        }
      }
      .passwordInputBox {
        width: 70%;
        @media (max-width: ${styleSizes.miniBreakpoint}) {
          width: 80%;
        }
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          width: 100%;
        }

      }
    }
  }

  /* @media only screen and (max-width: 1200px) {

    .innerContainer {
      flex-direction: column-reverse;
      padding: 0;
      margin: 0;
    }

    .titleContainer {
      height: auto;

      .titleText {
        margin: 20px 0;

        .title {
          text-align: center;
          font-size: 36px;
        }

        .description {
          text-align: center;
        }
      }

      .setPasswordImage {
        max-width: 270px;
        min-width: 270px;
        height: 183px;
        margin-top: 20px;
      }
    }
  } */
`;